import React, { useState, useEffect } from 'react';

import style from './block.module.scss';
import { ReactComponent as Close } from './close.svg';
import { defineBlock, smartProps, useEditor, useInspectorControl } from '@smartfire/js-block-engine';
import { EditableText, EditableImg } from '@smartfire/components';
import { GuedelonButton } from '../bouton-guedelon/button';

const InspectorLazy = React.lazy(() => import('./Inspector'));

function Block({ activated, buttonMode, buttonLink, imageActivated }) {
    useInspectorControl(InspectorLazy, []);
    const { isEditing } = useEditor();
    const [seen, setSeen] = useState(() => {
        try {
            const item = window.sessionStorage.getItem('popupSeen');
            return item ? JSON.parse(item) : false;
        } catch (error) {
            return false;
        }
    });

    useEffect(() => {
        if (seen) {
            window.sessionStorage.setItem('popupSeen', 'true');
        }
    }, [seen]);

    return (
        <div className={isEditing ? style.adminBlock : seen || !activated ? style.hiddenBlock : style.block}>
            {(isEditing || (activated && !seen)) && (
                <>
                    {!isEditing && <div className={style.openBackground} onClick={() => setSeen(true)} />}
                    <div className={style.popup}>
                        <div className={style.header}>
                            <div className={style.titleContainer}>
                                <EditableText tagName="h4" smartProp="title" />
                            </div>
                            <button className={style.closeButton} onClick={() => setSeen(true)}>
                                <Close />
                            </button>
                        </div>

                        <div className={style.content}>
                            <EditableText
                                allowedFormats={['core/bold', 'advanced/color']}
                                tagName="p"
                                smartProp="text1"
                            />
                            <EditableText
                                allowedFormats={['core/bold', 'advanced/color']}
                                tagName="p"
                                smartProp="text2"
                            />
                            {imageActivated && <EditableImg className={style.image} smartProp="image" />}
                            <GuedelonButton
                                onClick={() => setSeen(true)}
                                href={buttonMode || isEditing ? undefined : buttonLink}
                                className={style.button}
                            >
                                <EditableText tagName="span" smartProp="buttonText"></EditableText>
                            </GuedelonButton>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}

export default defineBlock({
    Block: Block as React.FC<unknown>,
    smartProps: {
        title: smartProps.string.withDefault(''),
        text1: smartProps.string.withDefault(''),
        text2: smartProps.string.withDefault(''),
        image: smartProps.image.withDefault({}),
        imageActivated: smartProps.bool.withDefault(false),
        buttonText: smartProps.string.withDefault(''),
        buttonLink: smartProps.string.withDefault(''),
        activated: smartProps.bool.withDefault(false),
        buttonMode: smartProps.bool.withDefault(true),
    },
    setup: {
        title: 'Pop-up',
    },
});
